import React from "react";
import StandardsPerformanceChart from "./StandardsPerformanceChart";
import SchoolComparisonChart from "./SchoolComparisonChart";
import ProgressAndAssessmentScoresChart from "./ProgressAndAssessmentScoresChart";

const Charts = ({ chartData, loading = false, error = null }) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
      <StandardsPerformanceChart
        loading={loading}
        error={error}
        data={chartData?.standardsPerformance}
      />
      <SchoolComparisonChart
        loading={loading}
        error={error}
        data={chartData?.schoolComparison}
      />
      <ProgressAndAssessmentScoresChart
        loading={loading}
        error={error}
        data={chartData?.progressAndAssessmentScores}
      />
    </div>
  );
};

export default Charts;
